import React from "react";
import FaturamentoCards from "./Faturamento/FaturamentoCards";
import FaturamentoDataTable from "./Faturamento/FaturamentoDataTable";
import Card from "../../components/page/Card";
import FaturamentoMeiDataTable from "./Faturamento/FaturamentoMeiDataTable";
import FaturamentoFiltro from "./Faturamento/FaturamentoFiltro";
import { hoje } from "../../helpers/mesesHelper";
import TabList from "../../components/Tab/TabList";
import TabButton from "../../components/Tab/TabButton";
import TabContent from "../../components/Tab/TabContent";
import TabPane from "../../components/Tab/TabPane";
import FaturamentoModal from "./Faturamento/FaturamentoModal";
import Validation from "../../helpers/Validation";
import ErrorSwal from "../../components/Swal/errorSwal";
import CommonSwal from "../../components/Swal/commonSwal";
import FaturamentoApiClient from "../../api/faturamento";
import useApi from "../../hooks/useApi";
import { AppContext } from "../../contexts/AppContext";

function Faturamento() {
  const [cards, setCards] = React.useState({});
  const [mei, setMei] = React.useState(false);
  const [meiMe, setMeiMe] = React.useState(null);
  const [faturamentos, setFaturamentos] = React.useState([]);
  const [faturamentosMei, setFaturamentosMei] = React.useState([]);
  const [faturamentoModal, setFaturamentoModal] = React.useState(false);
  const [values, setValues] = React.useState({});
  const [filtros, setFiltros] = React.useState({
    ano: hoje.getFullYear(),
  });
  const [linhaFooter, setLinhaFooter] = React.useState({});
  const [linhaFooterMei, setLinhaFooterMei] = React.useState({});
  const { session } = React.useContext(AppContext);

  const getFaturamentoCb = React.useCallback(
    (ano = null) => {
      return FaturamentoApiClient.getFaturamento(
        session.empresa.replace(/E/gi, ""),
        {
          ano: ano ? ano : filtros.ano,
          tipo_empresa: session.tipo_empresa,
        }
      );
    },
    [filtros.ano, session.empresa, session.tipo_empresa]
  );

  const { request: getFaturamentos, data: faturamentosResponse } =
    useApi(getFaturamentoCb);
  const putFaturamentoApi = useApi(FaturamentoApiClient.putFaturamento);

  //Busca faturamentos ao renderizar tela
  React.useLayoutEffect(() => {
    if (session.empresa) {
      getFaturamentos();
    }
  }, [getFaturamentos, session.empresa]);

  //Define o retorno do backend nos valores das linhas
  React.useEffect(() => {
    if (faturamentosResponse) {
      const receita_internacional = faturamentosResponse.result.reduce(
        (acc, cur) => {
          return (
            acc + cur.receita_internacional + cur.receita_nacional_adicional
          );
        },
        0
      );
      const receita_nacional = faturamentosResponse.result.reduce(
        (acc, cur) => {
          return (
            acc + cur.receita_nacional + cur.receita_internacional_adicional
          );
        },
        0
      );
      const receita_internacional_mei = faturamentosResponse.result_mei.reduce(
        (acc, cur) => {
          return (
            acc +
            cur.receita_internacional +
            cur.receita_internacional_adicional
          );
        },
        0
      );
      const receita_nacional_mei = faturamentosResponse.result_mei.reduce(
        (acc, cur) => {
          return acc + cur.receita_nacional + cur.receita_nacional_adicional;
        },
        0
      );
      const transformedFaturamentos = faturamentosResponse.result.map(
        (item) => ({
          mes: String(item.mes),
          receita_nacional: parseFloat(item.receita_nacional),
          receita_internacional: parseFloat(item.receita_internacional),
          receita_internacional_adicional: parseFloat(
            item.receita_nacional_adicional
          ),
          receita_nacional_adicional: parseFloat(
            item.receita_internacional_adicional
          ),
          valor_total: parseFloat(item.valor_total),
          me: true,
        })
      );

      setFaturamentos(transformedFaturamentos);
      setFaturamentosMei(faturamentosResponse.result_mei);
      setLinhaFooter({
        mes: "Total",
        receita_internacional: receita_internacional,
        receita_internacional_adicional: 0,
        receita_nacional: receita_nacional,
        receita_nacional_adicional: 0,
        valor_total: receita_internacional + receita_nacional,
      });
      setLinhaFooterMei({
        mes: "Total",
        receita_internacional: receita_internacional_mei,
        receita_internacional_adicional: 0,
        receita_nacional: receita_nacional_mei,
        receita_nacional_adicional: 0,
        valor_total: receita_internacional_mei + receita_nacional_mei,
      });
      setMeiMe(faturamentosResponse.mei_me);
      setMei(faturamentosResponse.result.length === 0);

      setCards({
        valor_total: faturamentosResponse.valor_total,
        receita_nacional: receita_nacional,
        receita_internacional: receita_internacional,
        valor_limite:
          faturamentosResponse.valor_permitido -
          (receita_internacional_mei + receita_nacional_mei),
        valor_permitido: faturamentosResponse.valor_permitido,
      });
    }
  }, [faturamentosResponse]);

  const togInvoicingModal = (data) => {
    setFaturamentoModal(true);
    setValues({
      data_faturamento: `${data.ano}-${String(data.mes).padStart(2, "0")}`,
      notas_orangiuz_servico: data.receita_internacional || 0,
      notas_orangiuz_comercio: data.receita_nacional || 0,
      valor_servico: data.receita_internacional_adicional || 0,
      valor_comercio: data.receita_nacional_adicional || 0,
      me: data?.me,
    });
  };

  const salvaFaturamento = async () => {
    const formData = new FormData();
    formData.append("data_faturamento", values?.data_faturamento);

    if (values?.me) {
      formData.append("valor_comercio", values?.valor_servico);
      formData.append("valor_servico", values?.valor_comercio);
    } else {
      formData.append("valor_comercio", values?.valor_comercio);
      formData.append("valor_servico", values?.valor_servico);
    }

    if (Validation.verificarForm(formData))
      return ErrorSwal({
        text: "Favor preencher todos os dados obrigatórios.",
      });

    const response = await putFaturamentoApi.request(
      session.empresa.replace(/E/gi, ""),
      formData
    );
    if (!response) return;
    CommonSwal({
      title: "Faturamento salvo com sucesso",
      icon: "success",
    });
    setFaturamentoModal(false);
    getFaturamentos();
  };

  return (
    <>
      <div className="row">
        <FaturamentoCards cards={cards} mei={mei} />
        <Card>
          <FaturamentoFiltro filtrosHook={{ filtros, setFiltros }} />
          {faturamentos.length > 0 && faturamentosMei.length > 0 ? (
            <TabList>
              <TabButton
                href="faturamento"
                ativo={!mei}
                onClick={() => {
                  setMei(false);
                }}
                customClasses="col-md-3"
              >
                Faturamento
              </TabButton>
              <TabButton
                href="faturamento"
                ativo={mei}
                onClick={() => {
                  setMei(true);
                }}
                customClasses="col-md-3"
              >
                Faturamento MEI
              </TabButton>
            </TabList>
          ) : (
            <></>
          )}
          <TabContent>
            <TabPane id="faturamento" ativo={!mei}>
              <FaturamentoDataTable
                linhas={faturamentos}
                togFaturamento={togInvoicingModal}
                ano={filtros.ano}
                meiMe={meiMe}
                linhaFooter={linhaFooter}
              />
            </TabPane>
            <TabPane id="faturamento" ativo={mei}>
              <FaturamentoMeiDataTable
                linhas={faturamentosMei}
                togFaturamento={togInvoicingModal}
                ano={filtros.ano}
                meiMe={meiMe}
                linhaFooter={linhaFooterMei}
              />
            </TabPane>
          </TabContent>
        </Card>
      </div>
      <FaturamentoModal
        mei={mei}
        modalHook={{ faturamentoModal, setFaturamentoModal }}
        salvaFaturamento={salvaFaturamento}
        valuesHook={{ values, setValues }}
      />
    </>
  );
}

export default Faturamento;
